import * as React from 'react';
import {navigate} from 'router';

import CurrentSaleInjector from '~/apps/shared/containers/sale/CurrentSaleInjector';
import SaleDetail from '../../components/sales/SaleDetail';
import {createRouteNodeSelector} from "redux-router5";
import {connect} from "react-redux";
import {useMemo} from "react";
import {parseSaleFilter, saleFilterParams} from "~/apps/pos/shared/services/qsfilter";

const SaleDetailPopup = (props) => {
  const {route: {params}, saleId} = props;

  const filters = useMemo(() => {
    return parseSaleFilter(params);
  }, [params]);

  return (
    <CurrentSaleInjector
      component={SaleDetail}
      saleId={saleId}
      onReturn={() => navigate('pos.admin.sales', saleFilterParams(filters))}
    />
  );
};

const mapStateToProps = (state) => {
  const selector = createRouteNodeSelector('pos.admin');

  return {
    ...selector(state)
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SaleDetailPopup);
